export const state = {
  niveau: undefined,
  niveaux: [],
  communes: [],
  sousNiveau: undefined,
  sousNiveaux: []
}